module.exports = __webpack_public_path__ + "img/preparing-food.75a91f0a.gif";